function parseDateTime(dateTime) {
  const dateTimeSplit = dateTime.split('T')
  const date = dateTimeSplit[0].split('-')
  const year = date[0]
  const month = date[1]
  const day = date[2]
  const time = dateTimeSplit[1].split('.')

  return `${month}-${day}-${year} @ ${time[0]}`
}

export default parseDateTime